import { graphqlRequest } from "./client";

export interface SimulationResult {
  message: string;
  done: string[];
  bidsCounted: number;
}

let enabled: Promise<boolean> | null = null;

/** Whether the API offers the local test-drive simulator. Asked once per session; false on any error. */
export function fetchSimulatorEnabled(): Promise<boolean> {
  if (!enabled) {
    enabled = graphqlRequest<{ simulatorEnabled: boolean }>(`{ simulatorEnabled }`)
      .then((data) => data.simulatorEnabled)
      .catch(() => false);
  }
  return enabled;
}

/** Local only: fill in a gig or finance step through the real services. */
export async function simulateStep(
  pathway: "gig" | "finance",
  step: number,
  complete: boolean,
): Promise<SimulationResult> {
  const field = pathway === "gig" ? "simulateGigStep" : "simulateFinanceStep";
  const data = await graphqlRequest<Record<string, SimulationResult>>(
    `mutation($step: Int!, $complete: Boolean!) { ${field}(step: $step, complete: $complete) { message done bidsCounted } }`,
    { variables: { step, complete } },
  );
  return data[field] as SimulationResult;
}

/** Test seam. */
export function resetSimulatorCache(): void {
  enabled = null;
}
